import React from "react";
import { FormattedMessage } from "react-intl";
import BadgeIcon from "../../../../../../assets/images/iconos/badge.png";
import {
  StyledTriDataWrapper,
  StyledTriIcon,
  StyledTriItem,
  StyledTriOwnerData,
  StyledTriOwnerLabel,
} from "./ContractCardSC";
import ContractOwnerSelect from "./ContractOwnerSelect";

interface IContractOwnershipProps {
  contractOwnerId?: string;
  contractOwnerName?: string;
  serviceOwnerName?: string;
  contractCrmIdName?: string;
  onChangeContractOwner: (newOwnerId: string, newOwnerName: string) => void;
}

const ContractOwnership: React.FC<IContractOwnershipProps> = (props) => {
  const {
    contractOwnerId,
    contractOwnerName,
    serviceOwnerName,
    contractCrmIdName,
    onChangeContractOwner,
  } = props;

  return (
    <>
      {!!serviceOwnerName && serviceOwnerName !== contractOwnerName ? (
        <StyledTriItem>
          <StyledTriIcon src={BadgeIcon} />
          <StyledTriDataWrapper>
            <ContractOwnerSelect
              contractOwnerId={contractOwnerId ?? ""}
              contractOwnerName={contractOwnerName ?? ""}
              contractCrmIdName={contractCrmIdName}
              onChangeContractOwner={onChangeContractOwner}
            />
            <StyledTriOwnerLabel>
              <FormattedMessage
                id="ContractCard.Propietario servicio"
                defaultMessage="Propietario servicio"
              />
            </StyledTriOwnerLabel>
            <StyledTriOwnerData>{serviceOwnerName}</StyledTriOwnerData>
          </StyledTriDataWrapper>
        </StyledTriItem>
      ) : (
        <StyledTriItem>
          <StyledTriIcon src={BadgeIcon} />
          <StyledTriDataWrapper>
            <ContractOwnerSelect
              contractOwnerId={contractOwnerId ?? ""}
              contractOwnerName={contractOwnerName ?? ""}
              contractCrmIdName={contractCrmIdName}
              onChangeContractOwner={onChangeContractOwner}
            />
          </StyledTriDataWrapper>
        </StyledTriItem>
      )}
    </>
  );
};

export default ContractOwnership;
